import { Suspense } from 'react';
import { X } from 'lucide-react';
import { useStore, type InspectorTab } from '@/state/store';
import { Segmented } from '@/components/ui/Segmented';
import { IconButton } from '@/components/ui/Button';
import { TOOLS } from '@/tools/registry';

/** `onClose` is passed only when the panel is an overlay drawer. */
export function Inspector({ onClose }: { onClose?: () => void } = {}) {
  const tool = useStore((s) => s.tool);
  const tab = useStore((s) => s.ui.tab);
  const setUi = useStore((s) => s.setUi);

  const def = TOOLS[tool];
  // A tab from the previous tool would render an empty panel body.
  const active = def.tabs.some((t) => t.value === tab) ? tab : def.defaultTab;
  const Panel = def.panels[active];

  return (
    <div className="flex h-full flex-col">
      <div className="flex items-center gap-1.5 px-2.5 py-2.5 hairline-b">
        <Segmented<InspectorTab>
          full
          value={active}
          onChange={(v) => setUi({ tab: v })}
          options={def.tabs.map(({ value, label, icon: Icon }) => ({
            value,
            label: (
              <>
                <Icon size={13} /> {label}
              </>
            ),
          }))}
        />
        {onClose && (
          <IconButton label="Close panel" onClick={onClose}>
            <X size={16} />
          </IconButton>
        )}
      </div>
      <div className="scroll-thin flex-1 overflow-y-auto">
        <Suspense fallback={null}>{Panel && <Panel />}</Suspense>
      </div>
    </div>
  );
}
